import { Outlet, useMatches } from "react-router";

import { RouteHead } from "../components/seo/RouteHead";
import { AppShell } from "../components/shell/AppShell";
import { PageTransition } from "../components/shell/PageTransition";

import type { RouteHandle } from "./config";

export function Layout() {
  const matches = useMatches();
  const handle = matches.findLast((m) => m.handle != null)?.handle as
    | RouteHandle
    | undefined;

  return (
    <AppShell>
      {handle?.seo && <RouteHead routeKey={handle.seo} />}
      <PageTransition>
        <Outlet />
      </PageTransition>
    </AppShell>
  );
}
